import React from "react";
import Skeleton from "@mui/material/Skeleton";

const NFLookupEmptyForms = () => {
  return (
    <>
      <div className="d-flex">
        <Skeleton
          variant="text"
          width="10%"
          height={50}
          className="me-3"
          animation="wave"
        />
        <Skeleton
          variant="text"
          width="10%"
          height={50}
          className="me-3"
          animation="wave"
        />
        <Skeleton
          variant="text"
          width="10%"
          height={50}
          className="me-3"
          animation="wave"
        />
        <Skeleton
          variant="text"
          width="10%"
          height={50}
          className="me-3"
          animation="wave"
        />
      </div>
      <div className="d-flex justify-content-between">
        <Skeleton
          variant="text"
          width="15%"
          height={50}
          className="me-3"
          animation="wave"
        />
        <Skeleton
          variant="text"
          width="15%"
          height={50}
          className="me-auto"
          animation="wave"
        />

        <Skeleton
          variant="text"
          width="15%"
          height={50}
          className="me-3"
          animation="wave"
        />
        <Skeleton variant="text" width="15%" height={50} animation="wave" />
      </div>
      <div className="d-flex justify-content-between">
        <div style={{ width: "45%" }}>
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
        </div>
        <div style={{ width: "45%" }}>
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
          <Skeleton variant="text" width="100%" height={50} animation="wave" />
        </div>
      </div>
    </>
  );
};

export default NFLookupEmptyForms;
